"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const home_module_scss_1 = __importDefault(require("./home.module.scss"));
const FilterContext_1 = require("../../../context/filters/FilterContext");
const filtersHelpers_1 = require("../../../common/utils/filtersHelpers");
const flags_1 = require("../../../common/feature-flags/flags");
const constants_1 = require("../../../routes/constants");
const cardsData = [
    {
        title: 'machines',
        icon: 'pi pi-database',
        path: '/machines/list',
        color: '#003366',
        textColor: '#FFFFFF',
    },
    {
        title: 'reFills',
        icon: 'pi pi-sync',
        path: '/reFills/list',
        color: '#FFDD57',
        textColor: '#003366',
    },
    {
        title: 'products',
        icon: 'pi pi-shopping-cart',
        path: '/products/list',
        color: '#50C878',
        textColor: '#FFFFFF',
    },
    {
        title: 'orders',
        icon: 'pi pi-clipboard',
        path: '/orders/list',
        color: '#FF5733',
        textColor: '#FFFFFF',
    },
    {
        title: 'billing',
        icon: 'pi pi-receipt',
        path: '/billing/list',
        color: '#34495E',
        textColor: '#FFFFFF',
    },
    {
        title: 'settlement',
        icon: 'pi pi-money-bill',
        path: '/settlement/list',
        color: '#3498DB',
        textColor: '#FFFFFF',
    },
    {
        title: 'advertising.title',
        icon: 'pi pi-megaphone',
        path: constants_1.ROUTE_ADVERTISING_LIST,
        color: '#6D28D9',
        textColor: '#FFFFFF',
    },
];
const Home = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { setFilters } = (0, FilterContext_1.useFilters)();
    const advertisingEnabled = (0, flags_1.useFeatureFlag)('advertisingEnabledVending');
    const cards = advertisingEnabled
        ? cardsData
        : cardsData.filter((card) => card.path !== constants_1.ROUTE_ADVERTISING_LIST);
    const handleCardClick = () => {
        localStorage.removeItem('filters');
        setFilters((0, filtersHelpers_1.getInitialFilters)());
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: home_module_scss_1.default.container, children: (0, jsx_runtime_1.jsx)("div", { className: home_module_scss_1.default.content, children: cards.map((card, index) => ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: card.path, onClick: handleCardClick, className: home_module_scss_1.default.cardLink, children: (0, jsx_runtime_1.jsxs)("div", { className: home_module_scss_1.default.card, style: { backgroundColor: card.color, color: card.textColor }, children: [(0, jsx_runtime_1.jsx)("div", { className: home_module_scss_1.default.cardIconWrapper, children: (0, jsx_runtime_1.jsx)("i", { className: `${card.icon} ${home_module_scss_1.default.cardIcon}` }) }), (0, jsx_runtime_1.jsx)("i", { className: `pi pi-arrow-right ${home_module_scss_1.default.cardArrow}`, style: { color: card.textColor } }), (0, jsx_runtime_1.jsx)("span", { className: home_module_scss_1.default.cardTitle, children: t(card.title) })] }) }, index))) }) }));
};
exports.Home = Home;
